import { Injectable } from '@angular/core';
import { UserRole } from '@p2p/users/domain';
import { Observable, of } from 'rxjs';

import { rolesPermissions, userCreationRolesPermissions } from '../constants/roles-permissions';
import { PermissionsResponse } from '../entities/permissions-response';

@Injectable({ providedIn: 'root' })
export class PermissionsDataService {
    getPermissions(userRole: UserRole): Observable<PermissionsResponse> {
        return of({
            permissions: rolesPermissions[userRole]
        });
    }

    getRolesForUserCreation(userRole: UserRole): Observable<UserRole[]> {
        return of(userCreationRolesPermissions[userRole]);
    }
}
